var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 3,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 26L26 2",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordDisabled);
export default __webpack_public_path__ + "static/media/record-disabled.0b2dcc7995e3caf8e9008af46177aa93.svg";
export { ForwardRef as ReactComponent };